/* eslint-disable */
export let plotNames;

export default function init(Blockly, profile) {
    Blockly.Arduino.serial = {};
    function setupSerial() {
        Blockly.Arduino.setups_.setup_serial ||
        (Blockly.Arduino.setups_.setup_serial =
            '  Serial.begin(9600);\n'+
            '  Serial.flush();\n'+
            '  while(Serial.available() > 0) Serial.read();\n')
    }
    Blockly.Arduino.serial_init = function() {
        var a = this.getFieldValue("BAUD");
        Blockly.Arduino.setups_.setup_serial =
            '  Serial.begin(' + a + ');\n'+
            '  Serial.flush();\n'+
            '  while(Serial.available() > 0) Serial.read();\n';
        return ""
    };
    Blockly.Arduino.serial_timeout = function() {
        setupSerial();
        return "Serial.setTimeout(" + Blockly.Arduino.valueToCode(this, "MS", Blockly.Arduino.ORDER_ATOMIC) + ");\n"
    };
    Blockly.Arduino.serial_print = function() {
        setupSerial();
        var a = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''";
        return "TRUE" == this.getFieldValue("NEWLINE") ? "Serial.println(" + a + ");\n" : "Serial.print(" + a + ");\n"
    };
    Blockly.Arduino.serial_println = function() {
        setupSerial();
        return "Serial.println(" + (Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''") + ");\n"
    };
    Blockly.Arduino.serial_write_byte = function() {
        setupSerial();
        return "Serial.write((byte)" + (Blockly.Arduino.valueToCode(this, "BYTE", Blockly.Arduino.ORDER_ATOMIC) || "0") + ");\n"
    };
    Blockly.Arduino.serial_read_float = function() {
        setupSerial();
        return ["TRUE" == this.getFieldValue("NEWLINE") ? "atof((Serial.readStringUntil('\\n')).c_str())" : "Serial.parseFloat()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.serial_read_byte = function() {
        setupSerial();
        return ["Serial.read()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.serial_read_string = function() {
        setupSerial();
        return ["TRUE" == this.getFieldValue("NEWLINE") ? "Serial.readStringUntil('\\n')" : "Serial.readString()", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.serial_read_string_line = function() {
        setupSerial();
        code = "Serial.readStringUntil('\\n')";
        return [code, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.serial_read_available = function() {
        setupSerial();
        return ["(Serial.available()>0)", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.serial_interrupt = function() {
        var a = this.getFieldValue("INT"),
            b = Blockly.Arduino.statementToCode(this, "DO");
        b = "void serialEvent" + a + "(){\r\n" + (b + "\r\n}\r\n\r\n");
        Blockly.Arduino.definitions_fnc_["fnc_serialInterrupt" + a] = b;
        return ""
    };
    Blockly.Arduino.serial_plot = function() {
        setupSerial();
        var code;
        var nItems = this.itemCount_;
        var elements = Array(this.itemCount_);
        plotNames = Array(this.itemCount_);
        for (var i = 0; i < nItems; i++) {
              elements[i] = Blockly.Arduino.valueToCode(this, "ADD" + i, Blockly.Arduino.ORDER_NONE) || "0";
              plotNames[i] = this.getFieldValue("NAME" + i) || "unamed";
            }
        code = "Serial.println (\n";
        for (var i = 0; i < nItems; i++) {
            var pre = "  String(";
            var item = elements[i];
            var pos = (i == nItems - 1)? ")" : ") + \", \" +\n";

            code +=  (pre + item + pos);
        }
        code += "\n);\n"
        return code;
   };
   // experimental
   Blockly.Arduino.serial_plot_group = function() {
     return 'Serial.println (\n'+ Blockly.Arduino.statementToCode(this, "DO") + ');\n';
   };
   // experimental
   Blockly.Arduino.serial_named_plot = function() {
     var name = (this.getFieldValue("NAME")) || "value";
     var value = Blockly.Arduino.valueToCode(
        this,
        "VALUE",
        Blockly.Arduino.ORDER_ATOMIC
      ) || 0;
     var code;
     return code = name + ' = ' + value + '\n';
   };

};